// eslint-disable-next-line no-restricted-imports
import * as Sentry from '@sentry/vue';
import type { App } from 'vue';
import type { Router } from 'vue-router';

export function initSentry(app: App, router: Router): void {
  if (!import.meta.env.VITE_SENTRY_DSN) {
    console.info('Could not load VITE_SENTRY_DSN from env');
    return;
  }

  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracePropagationTargets: [
      'localhost',
      'admin.klimate.co',
      'klimate-as-admin-staging.azurewebsites.net',
      'klimate-as-admin-sales.azurewebsites.net',
    ],
    tracesSampleRate: 1.0,
  });
}

export function setAuthenticatedUserSentry(userId: string, email?: string): void {
  Sentry.setUser({ id: userId, email });
}
